import React from 'react';

import type { Node } from './../ricos-schema/legacy/wix/rich_content/v1';
import { Decoration_Type } from './../ricos-schema/legacy/wix/rich_content/v1';
import type { ColorDecoration, NodeViewDecorator, ViewerContextualData } from './../ricos-types';

import { TEXT_COLOR_TYPE, TEXT_HIGHLIGHT_TYPE } from './types';

const TO_PROPERTY = {
  [TEXT_COLOR_TYPE]: 'color',
  [TEXT_HIGHLIGHT_TYPE]: 'backgroundColor',
};

const decorator = (
  element: JSX.Element,
  colorDecoration: ColorDecoration,
  context: ViewerContextualData
) => {
  const shouldParseColor = (type: string, color: string | undefined) => {
    return context.config?.[type]?.styleSelectionPredicate?.(color);
  };
  const parseColor = (type: string, color: string | undefined) => {
    return context.config?.[type]?.customStyleFn(color);
  };
  const getColor = (type: keyof typeof TO_PROPERTY, color: string | undefined) => {
    return shouldParseColor(type, color) ? parseColor(type, color) : { [TO_PROPERTY[type]]: color };
  };
  const { foreground, background } = colorDecoration?.colorData || {};
  return (
    <span
      key={`color-${element.key}`}
      style={{
        ...getColor(TEXT_COLOR_TYPE, foreground),
        ...getColor(TEXT_HIGHLIGHT_TYPE, background),
        textDecoration: 'inherit',
      }}
    >
      {element}
    </span>
  );
};

const ColorDecorator: NodeViewDecorator<JSX.Element> = {
  rule: (node: Node) => {
    return !!node.textData?.decorations?.some(({ type }) => type === Decoration_Type.COLOR);
  },
  decorate: ({ element, node, context }) => {
    const colorDecoration = node.textData?.decorations?.find(
      ({ type }) => type === Decoration_Type.COLOR
    ) as ColorDecoration;
    return decorator(element as JSX.Element, colorDecoration, context);
  },
};

export default ColorDecorator;
